import { precompileTemplate } from '@ember/template-compilation';
export default precompileTemplate(`{{component this}}`, {
  moduleName: 'packages/@ember/-internals/glimmer/lib/templates/root.hbs',
  strictMode: true,
});
